import Vue from 'vue'
import store from '@/store'
import { jiminnyHost } from '@/helpers/region'
import LiveCoachPlugin from 'vue-components/live-coach'
import lstore from '@/lib/store'

Vue.use(LiveCoachPlugin, {
  store,
  jiminnyHost,
  hostApp: 'extension-app',
  getTeam () {
    return lstore.get('team')
  }
})



// WEBPACK FOOTER //
// ./src/plugins/live-coach.js